// @ts-strict-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getCorrectAcsName = (count: number): string => {
	if (count === 1) {
		return `aксесcуар`
	}

	if (1 < count && count < 5) {
		return `aксессуара`
	}

	if (count > 4) {
		return `aксессуаров`
	}
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getCorrectServiceName = (count: number): string => {
	if (count === 1) {
		return `услуга`
	}

	if (1 < count && count < 5) {
		return `услуги`
	}

	if (count > 4) {
		return `услуг`
	}
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const getCorrectProductName = (count: number): string => {
	if (count === 1) {
		return `товар`
	}

	if (1 < count && count < 5) {
		return `товара`
	}

	if (count > 4) {
		return `товаров`
	}
}
